// Currency + date formatting helpers, ported from the prototype's fmt()/todayLocal().

export const CURRENCY_META: Record<string, { symbol: string }> = {
  EUR: { symbol: '€' },
  RON: { symbol: 'lei' },
  HUF: { symbol: 'Ft' },
  CZK: { symbol: 'Kč' },
  DKK: { symbol: 'kr' },
  NOK: { symbol: 'kr' },
  SEK: { symbol: 'kr' },
};

// Approx display-only conversion rates to EUR. Never used to silently merge amounts —
// any total computed with these is always labeled "≈" / "approximate" in the UI
// (spec §19 rule 6, brief priority #4).
export const APPROX_RATE_TO_EUR: Record<string, number> = {
  EUR: 1,
  RON: 0.2,
  HUF: 0.0025,
  CZK: 0.04,
  DKK: 0.134,
  NOK: 0.086,
  SEK: 0.088,
};

export function currencySymbol(code: string): string {
  return CURRENCY_META[code]?.symbol || code;
}

export function fmt(amount: number, code: string): string {
  const sym = currencySymbol(code);
  const n = Number(amount).toLocaleString(undefined, { maximumFractionDigits: amount >= 1000 ? 0 : 2 });
  return code === 'EUR' ? sym + n : n + ' ' + sym;
}

export function todayLocal(): string {
  const d = new Date();
  const tzOffsetMs = d.getTimezoneOffset() * 60000;
  return new Date(d.getTime() - tzOffsetMs).toISOString().slice(0, 10);
}

export function monthShort(dateStr: string): string {
  const dt = new Date(dateStr + 'T00:00');
  return dt.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export function uid(): string {
  // Prefer crypto.randomUUID when available; fall back to the prototype's scheme.
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID().replace(/-/g, '').slice(0, 12);
  }
  return Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);
}

export function slug(s: string): string {
  return s
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

export function categoryColor(i: number): string {
  const palette = [
    '#39d97a',
    '#2fb8c9',
    '#f0b429',
    '#e07a5f',
    '#9d8cf1',
    '#f0554c',
    '#5fb0e0',
    '#c9e05f',
    '#e0a3f0',
    '#7ad4a0',
    '#d9b56f',
  ];
  return palette[i % palette.length];
}
